
export const isDevMachine = window.location.href.includes("localhost");

//export const ajaxUri = isDevMachine?"http://localhost:80/StartupAnalyticsPhp/command.php":"https://scheherazade.me/command.php"; 
export const ajaxUri = "https://scheherazade.me/command.php"; 

